<template>
    <div>

        <div v-if="action.isCompleted">

            <ActionProviderMessageComplete :action="action"/>

            <FileList :action="action"/>
            
        </div>

        <div v-else>

            <Uploader :action="action"
                      @uploaded="onUploaded"/>
            
        </div>

    </div>
</template>

<script>
import actionProvider from '@/mixins/actionProvider'

import FileList from './FileUpload/FileList'
import Uploader from './FileUpload/Uploader'

export default 
{
   name: 'ActionProviderFileUpload',

   mixins: [ actionProvider ],

   components: 
   {
    FileList,
    Uploader
   },

   data: () => ({
    
   }),

   props: {
    
   },

   computed: 
   {
    
   },

   methods:
   {
    
    onUploaded(data)
    {
        this.$emit('completed', data)
    }

   },

   mounted()
   {

   }
}
</script>